/*
 * Copyright (c) Dito Technologies
 */

import React from "react";
import styles from "ui/style/typography.module.scss"

interface Props {
    children: React.ReactNode;
}

const Header1: React.FC<Props> = ({children}) => {
    return (
        <p className={styles.header1}>{children}</p>
    )
}

export default Header1;
